// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__Pz3qB","error":"Alert_error__M7+ku","warning":"Alert_warning__Hkrgk","info":"Alert_info__pxbM4","success":"Alert_success__7ifEw"};